import Loading from "./Loading";
import FloatingScrollTrigger from "./FloatingScrollTrigger";
import CountUp from "./CountUp";
import MailCreator from "./MailCreator";
import FirstViewChanger from "./FirstViewChanger";

export default class {
  constructor() {
    const LoadingDom = document.querySelector('[data-js="loading"]');
    if (LoadingDom) new Loading(LoadingDom);

    const FloatingScrollTriggerDom = document.querySelectorAll('[data-js="floating-trigger"]');
    if (FloatingScrollTriggerDom) new FloatingScrollTrigger(FloatingScrollTriggerDom);

    const CountUpDom = document.querySelectorAll('[data-js="countup"]');
    if (CountUpDom) new CountUp(CountUpDom);

    const MailCreatorDom = document.querySelector('[data-js="mail"]');
    if (MailCreatorDom) new MailCreator(MailCreatorDom);

    const FirstViewChangerDom = document.querySelector('[data-js="changer"]');
    if (FirstViewChangerDom) new FirstViewChanger(FirstViewChangerDom);
  }
}
